import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aether_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("aether_token", token);
  else localStorage.removeItem("aether_token");
}

// Fire-and-forget flywheel analytics
export function track(type, meta = {}) {
  try {
    api.post("/analytics/track", { type, ...meta }).catch(() => {});
  } catch { /* noop */ }
}

// Resolve a stored/library image url to a loadable src (adds backend host + auth)
export function resolveImg(url) {
  if (!url) return url;
  if (url.startsWith("data:") || url.startsWith("http")) return url;
  if (url.startsWith("/api/studio/file")) {
    const t = localStorage.getItem("aether_token");
    return `${BACKEND_URL}${url}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
  }
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url; // frontend public asset
}
